module.exports = (__webpack_require__(0))(203);


//////////////////
// WEBPACK FOOTER
// delegated ./src/views/body/FrontPageView.js from dll-reference girder_lib
// module id = 20
// module chunks = 0